// Back to top: fades in once the shopper reaches the homepage's Pick Your Size section
// (or has scrolled about a screen down on other pages), and glides slowly back up when clicked.
const button = document.querySelector('[data-back-to-top]');
if (button) {
  const SCROLL_DURATION = 1600;
  const marker = document.getElementById('pick-your-size');

  const update = () => {
    const reached = marker
      ? marker.getBoundingClientRect().top < window.innerHeight * 0.6
      : window.scrollY > window.innerHeight;
    button.classList.toggle('is-visible', reached);
  };
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();

  const easeInOutCubic = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

  button.addEventListener('click', () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.scrollTo(0, 0);
      return;
    }
    const start = window.scrollY;
    const startTime = performance.now();
    let cancelled = false;
    // Stop gliding if the shopper takes over with the wheel, touch or keys.
    const cancel = () => { cancelled = true; };
    const cancelEvents = ['wheel', 'touchstart', 'keydown'];
    cancelEvents.forEach((name) => window.addEventListener(name, cancel, { passive: true, once: true }));

    const step = (now) => {
      if (cancelled) return;
      const t = Math.min((now - startTime) / SCROLL_DURATION, 1);
      window.scrollTo(0, start * (1 - easeInOutCubic(t)));
      if (t < 1) {
        requestAnimationFrame(step);
      } else {
        cancelEvents.forEach((name) => window.removeEventListener(name, cancel));
      }
    };
    requestAnimationFrame(step);
  });
}
